// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenuButton-cls1_7uO","cls2":"AccountMenuButton-cls2_yff AccountMenuButton-cls1_7uO"};